import dayjs from 'dayjs'
import { LoaderFunction, redirect } from 'react-router-dom'

import { FormattedSlot, Slot } from '@/apiTypes.ts'
import { useAppointmentStore } from '@/store.ts'
import { fetchFromApi } from '@/utils/fetchFromApi.ts'

type LoaderData = {
  error?: string
  slots?: FormattedSlot[]
  loadTime?: number
}

const loader: LoaderFunction<LoaderData> = async (): Promise<
  LoaderData | Response | null
> => {
  const { appointmentType, selectedLocation, setError, setSlots } =
    useAppointmentStore.getState()

  if (!selectedLocation || !appointmentType) {
    return null
  }

  const startTime = Date.now()
  try {
    const slotsResponse = await fetchFromApi(
      `slots?type=${appointmentType}&location=${selectedLocation.emmaId}`,
    )

    if (!slotsResponse.ok) {
      // Check for timeout error
      if (slotsResponse.status === 504) {
        const errorData = await slotsResponse.json()
        if (errorData.error === 'TIMEFF_TIMEOUT') {
          setError('timeffTimeoutXpert')
          return redirect('/error')
        }
      }
      setError('internalServerError')
      return redirect('/error')
    }

    const slots: Slot[] = await slotsResponse.json()
    const formattedSlots = slots.map((slot) => ({
      ...slot,
      end: dayjs(slot.end),
      start: dayjs(slot.start),
    }))

    setSlots(formattedSlots)
    return { loadTime: Date.now() - startTime, slots: formattedSlots }
  } catch (error) {
    console.error('Error fetching appointment slots:', error)
    return {
      error:
        error instanceof Error ? error.message : 'An unknown error occurred',
    }
  }
}

export type { LoaderData }
export { loader }
